import React, { useState, useEffect } from "react";
import "./common.css";
import API_URL from "../common/Apiurl";
import ExportExcel from "../excelsheet/Excelexport";
import * as XLSX from "xlsx";
import SuccessMessage from "../common/Message";

function Audit() {
  // new table
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [alldata, setAlldata] = useState([]);
  const [file, setFile] = useState(null);
  const [allhomeowner, setAllhomeowner] = useState([]);
  const [allemployer, setAllemployer] = useState([]);
  const [allprovider, setAllprovider] = useState([]);
  const [allchat, setAllchat] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);

  // import excel
  // const handleFileChangeProvider = (e) => {
  //   const file = e.target.files[0];
  //   setFile(file);
  //   const fileReader = new FileReader();
  //   fileReader.onload = async (e) => {
  //     // const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(e.target.result, { type: "binary" });
  //     const sheetName = workbook.SheetNames[0];
  //     const sheet = workbook.Sheets[sheetName];
  //     const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  //     console.log(jsonData);
  //     // storeInarray
  //     const newArray = [];
  //     const itemsValue = jsonData;
  //     itemsValue.map((dataItem, index) => {
  //       var putIndustryName = dataItem[0] ? dataItem[0] : "";
  //       var putfromtype = dataItem[1] ? dataItem[1] : "";
  //       var questionVal = dataItem[2] ? dataItem[2] : "";
  //       var answerVal = dataItem[3] ? dataItem[3] : "";
  //       var enterVal = dataItem[4] ? dataItem[4] : "";
  //       var quesOrderVal = dataItem[5] ? dataItem[5] : "";

  //       const newItem = {
  //         industry_id: putIndustryName,
  //         from_type: putfromtype,
  //         question: questionVal,
  //         answer_type: answerVal,
  //         enterValue: enterVal,
  //         questionOrder: quesOrderVal,
  //         user_type:'Provider'
  //       };
  //       newArray.push(newItem);
  //     });
  //     console.log(newArray);
  //     const ExcelExportData = newArray;
  //     const result = await fetch(`${apiUrl}/admin/csvupload`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //       body: JSON.stringify(ExcelExportData),
  //     });
  //     const data = await result.json();
  //     if (data.status == 200) {
  //       const newSuccessMessage = data.message;
  //       setSuccessMessages([...successMessages, newSuccessMessage]);
  //     } else if (data.status != 200) {
  //       const newSuccessMessage = "Please check your uploaded excelsheet";
  //       setSuccessMessages([...successMessages, newSuccessMessage]);
  //     }
  //     // storeInarray
  //   };
  //   fileReader.readAsBinaryString(file);
  // };
  // const handleFileChangeEmployer = (e) => {
  //   const file = e.target.files[0];
  //   setFile(file);
  //   const fileReader = new FileReader();
  //   fileReader.onload = async (e) => {
  //     // const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(e.target.result, { type: "binary" });
  //     const sheetName = workbook.SheetNames[0];
  //     const sheet = workbook.Sheets[sheetName];
  //     const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  //     console.log(jsonData);
  //     // storeInarray
  //     const newArray = [];
  //     const itemsValue = jsonData;
  //     itemsValue.map((dataItem, index) => {
  //       var putIndustryName = dataItem[0] ? dataItem[0] : "";
  //       var putfromtype = dataItem[1] ? dataItem[1] : "";
  //       var questionVal = dataItem[2] ? dataItem[2] : "";
  //       var answerVal = dataItem[3] ? dataItem[3] : "";
  //       var enterVal = dataItem[4] ? dataItem[4] : "";
  //       var quesOrderVal = dataItem[5] ? dataItem[5] : "";

  //       const newItem = {
  //         industry_id: putIndustryName,
  //         from_type: putfromtype,
  //         question: questionVal,
  //         answer_type: answerVal,
  //         enterValue: enterVal,
  //         questionOrder: quesOrderVal,
  //         user_type:'Employer'
  //       };
  //       newArray.push(newItem);
  //     });
  //     console.log(newArray);
  //     const ExcelExportData = newArray;
  //     const result = await fetch(`${apiUrl}/admin/csvupload`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //       body: JSON.stringify(ExcelExportData),
  //     });
  //     const data = await result.json();
  //     if (data.status == 200) {
  //       const newSuccessMessage = data.message;
  //       setSuccessMessages([...successMessages, newSuccessMessage]);
  //     } else if (data.status != 200) {
  //       const newSuccessMessage = "Please check your uploaded excelsheet";
  //       setSuccessMessages([...successMessages, newSuccessMessage]);
  //     }
  //     // storeInarray
  //   };
  //   fileReader.readAsBinaryString(file);
  // };
  const handleFileChangeProvider = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      const datas = new Uint8Array(event.target.result);
      const workbook = XLSX.read(datas, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(sheet);
      // setJsonData(excelData);
      console.log(excelData);
      const result = await fetch(`${apiUrl}/admin/csvupload`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(excelData),
          });
          const data = await result.json();
          if (data.status === 200) {
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
          } else if (data.status !== 200) {
            const newSuccessMessage = "Please check your uploaded excelsheet";
            setSuccessMessages([...successMessages, newSuccessMessage]);
          }
    };

    reader.readAsArrayBuffer(file);
    // setFile(file);

    // const fileReader = new FileReader();
    // fileReader.onload = async (e) => {
    //   // const data = new Uint8Array(e.target.result);
    //   const workbook = XLSX.read(e.target.result, { type: "binary" });
    //   const sheetName = workbook.SheetNames[0];
    //   const sheet = workbook.Sheets[sheetName];
    //   const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    //   console.log(jsonData);
    //   // storeInarray
    //   const newArray = [];
    //   const itemsValue = jsonData;
    //   // itemsValue.map((dataItem, index) => {
    //   //   // console.log(dataItem);
    //   //   // return
    //   //   var putIndustryName = dataItem[0] ? dataItem[0] : "";
    //   //   var putfromtype = dataItem[1] ? dataItem[1] : "";
    //   //   var questionVal = dataItem[2] ? dataItem[2] : "";
    //   //   var answerVal = dataItem[3] ? dataItem[3] : "";
    //   //   var enterVal = dataItem[4] ? dataItem[4] : "";
    //   //   var quesOrderVal = dataItem[5] ? dataItem[5] : "";
    //   //   // console.log(dataItem[2]);
    //   //   // return
        
    //   //   var user_type = "Provider";
    //   //   if (putfromtype === "employer") {
    //   //     user_type = "Employer";
    //   //   } else if (putfromtype === "homeowner") {
    //   //     user_type = "Homeowner";
    //   //   } else if (putfromtype === "provider") {
    //   //     user_type = "Provider";
    //   //   }
    //   //   const newItem = {
    //   //     industry_id: putIndustryName,
    //   //     from_type: 'creator',
    //   //     question: questionVal,
    //   //     answer_type: answerVal,
    //   //     enterValue: enterVal,
    //   //     questionOrder: quesOrderVal,
    //   //     user_type: user_type
    //   //   };
    //   //   newArray.push(newItem);
    //   // });
    //   console.log(newArray);
    //   const ExcelExportData = newArray;
    //   const result = await fetch(`${apiUrl}/admin/csvupload`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "application/json",
    //     },
    //     body: JSON.stringify(ExcelExportData),
    //   });
    //   const data = await result.json();
    //   if (data.status == 200) {
    //     const newSuccessMessage = data.message;
    //     setSuccessMessages([...successMessages, newSuccessMessage]);
    //   } else if (data.status != 200) {
    //     const newSuccessMessage = "Please check your uploaded excelsheet";
    //     setSuccessMessages([...successMessages, newSuccessMessage]);
    //   }
    //   // storeInarray
    // };
    // fileReader.readAsBinaryString(file);
  };

  const handleUpload = async () => {
    if (!file) {
      console.log("No File Selected");
      return;
    }
  };

  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    // window.location.reload();
  };
  // import excel

  useEffect(() => {
    const getComments = async () => {
      try {
        const res = await fetch(`${apiUrl}/admin/auditlog`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setAllhomeowner(data.homeowner);
        setAllemployer(data.employer);
        setAllprovider(data.provider);
        setAllchat(data.chatdata);
        // setItems(data.data);
        // setAlldata(data.data);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  // get industry

  const chatArray = [];
  const questionsArray = [];
  const chatValues = allchat;
  chatValues.map((dataItem, index) => {
    const reducedArray = dataItem.questionInfo.reduce((acc, curr) => {
      if (curr.question) {
        return `${acc}Questionby: ${curr.questionby}, Question: ${curr.question} | `;
      } else {
        return `${acc}Answerby: ${curr.answerby}, Answer: ${curr.answer} | `;
      }
    }, []);
    const newItem = {
      Number: index + 1,
      Jobtitle: dataItem.jobTitle,
      CreatorName: dataItem.creatorName,
      CreatorEmail: dataItem.creatorEmail,
      ProviderName: dataItem.providerName,
      ProviderEmail: dataItem.providerEmail,
      Questiondetails: reducedArray,
    };
    chatArray.push(newItem);
  });
  const ExcelExportchat = chatArray;

  const newArray = [];
  const itemsValue = allhomeowner;
  itemsValue.map((dataItem, index) => {
    const byname = dataItem.editedby;
    const ofname = dataItem.editedof;
    let editedByusername = "";
    let editedByuseremail = "";
    let editedOfusername = "";
    let editedOfuseremail = "";
    if (byname === "") {
      editedByusername = "";
      editedByuseremail = "";
    } else {
      editedByusername = byname.name;
      editedByuseremail = byname.email;
    }
    if (ofname === "") {
      editedOfusername = "";
      editedOfuseremail = "";
    } else {
      editedOfusername = ofname.name;
      editedOfuseremail = ofname.email;
    }
    const newItem = {
      Number: index + 1,
      Name: dataItem.name,
      EmailId: dataItem.emailaddress,
      Companyname: dataItem.companyname,
      Informations: dataItem.informations,
      Mobile_number: dataItem.contact_number,
      Password: dataItem.password,
      Office_location: dataItem.office_location,
      Home_address: dataItem.home_address,
      Edited_by_username: editedByusername,
      Edited_by_useremail: editedByuseremail,
      Edited_Of_username: editedOfusername,
      Edited_Of_useremail: editedOfuseremail,
      Updated_at: dataItem.updated_at,
    };
    newArray.push(newItem);
  });
  const ExcelExportData = newArray;

  const empnewArray = [];
  const empValue = allemployer;
  empValue.map((dataItem, index) => {
    const byname = dataItem.editedby;
    const ofname = dataItem.editedof;
    let editedByusername = "";
    let editedByuseremail = "";
    let editedOfusername = "";
    let editedOfuseremail = "";
    if (byname === "") {
      editedByusername = "";
      editedByuseremail = "";
    } else {
      editedByusername = byname.name;
      editedByuseremail = byname.email;
    }
    if (ofname === "") {
      editedOfusername = "";
      editedOfuseremail = "";
    } else {
      editedOfusername = ofname.name;
      editedOfuseremail = ofname.email;
    }
    const newItem = {
      Number: index + 1,
      Name: dataItem.name,
      EmailId: dataItem.emailaddress,
      Companyname: dataItem.companyname,
      Informations: dataItem.informations,
      Mobile_number: dataItem.contact_number,
      Password: dataItem.password,
      Office_location: dataItem.office_location,
      Home_address: dataItem.home_address,
      Edited_by_username: editedByusername,
      Edited_by_useremail: editedByuseremail,
      Edited_Of_username: editedOfusername,
      Edited_Of_useremail: editedOfuseremail,
      Updated_at: dataItem.updated_at,
    };
    empnewArray.push(newItem);
  });
  const ExcelExportemp = empnewArray;

  const providernewArray = [];
  const providerValue = allprovider;
  providerValue.map((dataItem, index) => {
    const byname = dataItem.editedby;
    const ofname = dataItem.editedof;
    let editedByusername = "";
    let editedByuseremail = "";
    let editedOfusername = "";
    let editedOfuseremail = "";
    if (byname === "") {
      editedByusername = "";
      editedByuseremail = "";
    } else {
      editedByusername = byname.name;
      editedByuseremail = byname.email;
    }
    if (ofname === "") {
      editedOfusername = "";
      editedOfuseremail = "";
    } else {
      editedOfusername = ofname.name;
      editedOfuseremail = ofname.email;
    }
    const newItem = {
      Number: index + 1,
      Name: dataItem.name,
      EmailId: dataItem.emailaddress,
      Companyname: dataItem.companyname,
      Informations: dataItem.informations,
      Mobile_number: dataItem.contact_number,
      Password: dataItem.password,
      Office_location: dataItem.office_location,
      Home_address: dataItem.home_address,
      Edited_by_username: editedByusername,
      Edited_by_useremail: editedByuseremail,
      Edited_Of_username: editedOfusername,
      Edited_Of_useremail: editedOfuseremail,
      Updated_at: dataItem.updated_at,
    };
    providernewArray.push(newItem);
  });
  const ExcelExportprovider = providernewArray;

  const multiquestionsArrayProvider = [
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Are you proficient in computer use, including Microsoft Office applications ?",
        "Answertype": "yes_no",
        "Entervalue": "",
        "Questionorder": "1",
        "QuestionAskedBy": "employer"
    },
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Are you proficient in computer use, including Microsoft Office applications ?",
        "Answertype": "yes_no",
        "Entervalue": "",
        "Questionorder": "1",
        "QuestionAskedBy": "homeowner"
    },
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Do you have any of the following accountancy qualifications ?",
        "Answertype": "options",
        "Entervalue": "CIMA, AACA, AAT, Other",
        "Questionorder": "2",
        "QuestionAskedBy": "employer"
    },
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Do you have any of the following accountancy qualifications ?",
        "Answertype": "options",
        "Entervalue": "CIMA, AACA, AAT, Other",
        "Questionorder": "2",
        "QuestionAskedBy": "homeowner"
    },
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Do you have experience using accounting software ?",
        "Answertype": "yes_no",
        "Entervalue": "",
        "Questionorder": "3",
        "QuestionAskedBy": "employer"
    },
    {
        "Industryname": "Accountancy",
        "Usertype": "creator",
        "Question": "Do you have experience using accounting software ?",
        "Answertype": "yes_no",
        "Entervalue": "",
        "Questionorder": "3",
        "QuestionAskedBy": "homeowner"
    }
  ];

  const ExcelExportdummyProvider = multiquestionsArrayProvider;

  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-6">
          <h2 className="pageTitle">Audit Log</h2>
        </div>
      </div>
      {/* excelsheet */}
      <div className="form-group mt-5">
        <div className="row">
          <div className="col-sm-3 text-center">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Homeowners Log
            </label>
            <ExportExcel
              excelData={ExcelExportData}
              fileName={"homeownerslog"}
            />
          </div>
          <div className="col-sm-3 text-center">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Employers Log
            </label>
            <ExportExcel excelData={ExcelExportemp} fileName={"employerslog"} />
          </div>
          <div className="col-sm-3 text-center">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Providers Log
            </label>
            <ExportExcel
              excelData={ExcelExportprovider}
              fileName={"providerslog"}
            />
          </div>
          <div className="col-sm-3 text-center">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Chat Data
            </label>
            <ExportExcel excelData={ExcelExportchat} fileName={"chathistory"} />
          </div>
        </div>
      </div>
      {/* excelsheet */}

      {/* import */}
      <div className="row mt-4">
        <div className="col-sm-3 mt-5 text-center">
          <input className="mx-3" type="file" onChange={handleFileChangeProvider} />
          <button className="mt-4 btn btn-primary" onClick={handleUpload}>
            Upload Questions
          </button>
        </div>
        <div className="col-sm-7 mt-5 text-center">
          <label
            className="control-label col-sm-10 label mb-4"
            htmlFor="exportData"
          >
            Dummy Excelsheet for uploading multiple questions.
          </label>
          <ExportExcel
            excelData={ExcelExportdummyProvider}
            fileName={"dummyexcelsheet"}
          />
        </div>
      </div>
      
      {/* import */}

      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

export default Audit;
